import { withIcon } from '@optimizely/axiom-icons';

export const IconBookRegular = withIcon(
  {
    icon: [
      20,
      16,
      [],
      '',
      [
        'M3 2.75C3 1.25 4.21875 0 5.75 0H15.25C16.1875 0 17 0.8125 17 1.75V10.75C17 11.4688 16.5625 12.0625 16 12.3438V14.5H16.25C16.6562 14.5 17 14.8438 17 15.25C17 15.6875 16.6562 16 16.25 16H5.5C4.09375 16 3 14.9062 3 13.5C3 13.4375 3 13.3438 3 13.25V2.75ZM5.5 12.5C4.9375 12.5 4.5 12.9688 4.5 13.5C4.5 14.0625 4.9375 14.5 5.5 14.5H14.5V12.5H5.5ZM4.5 11.2188C4.78125 11.0938 5.125 11 5.5 11H15.25C15.375 11 15.5 10.9062 15.5 10.75V1.75C15.5 1.625 15.375 1.5 15.25 1.5H5.75C5.03125 1.5 4.5 2.0625 4.5 2.75V11.2188ZM7.75 3.5H13.25C13.6562 3.5 14 3.84375 14 4.25C14 4.6875 13.6562 5 13.25 5H7.75C7.3125 5 7 4.6875 7 4.25C7 3.84375 7.3125 3.5 7.75 3.5ZM7.75 6H13.25C13.6562 6 14 6.34375 14 6.75C14 7.1875 13.6562 7.5 13.25 7.5H7.75C7.3125 7.5 7 7.1875 7 6.75C7 6.34375 7.3125 6 7.75 6Z',
      ],
    ],
    iconName: 'book-regular',
    prefix: 'ax',
  },
  'IconBookRegular'
);
